<template>    
  <v-app class="responsive" id="layout">

    <v-app-bar 
      dark
      app 
      clipped-left
      fixed
      elevation="2"
      class="app_bar_bg"      
      id="layoutAppBar">

      <v-app-bar-nav-icon @click.stop="drawer = !drawer" v-if="userInfo.sysCd!='23'"></v-app-bar-nav-icon>

      <v-spacer></v-spacer>
      <!-- {{menuName === 'main' ? '':menuName}} -->
      <v-toolbar-title>{{ menuName }}</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon 
        v-if="$route.name !='v20Menu'"
        @click="goHome()">
        <v-icon dark>mdi-home</v-icon>
      </v-btn>     
      <v-btn 
        v-if="$route.name=='v20Menu'"
        icon 
        @click="logout()">
        <v-icon >mdi-power</v-icon>
      </v-btn>
      <v-app-bar-nav-icon 
        class="hidden-md-and-up" 
        v-if="$route.name !== 'v'+ '20'+ 'Menu'" 
        @click="search">
        <v-icon >mdi-magnify</v-icon>
      </v-app-bar-nav-icon>

    </v-app-bar>

     <!-- navbar -->
      <!-- class="deep-purple accent-4"
      dark
      permanent 
      absolute
        temporary-->
     
      <v-navigation-drawer
        dark
        v-if="userInfo.sysCd!='23'"
        app
        clipped
        floating
        class="DefaultListGroup accent-4"
        v-model="drawer"
      >
        <v-list 
          nav
          dense
        >
          <!-- <div class="m-nav-top flex" style="justify-content: end;">
          <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon @click="goMain()">
                  <v-icon >mdi-export</v-icon>
                </v-btn>
              </template>
              <span>Main</span>
            </v-tooltip>            
          </div> -->
          <v-list-item
            v-for="(item, index) in systemMenuTreeList"
            :key="item.ename"
            link
          >
            <!-- <v-list-item-icon>
              <v-icon>mdi-message-text</v-icon>
            </v-list-item-icon> -->

            <v-list-item-content>
              <v-layout column>
                <v-flex mx-1>   
                  <v-card color="success" 
                      class="pa-2"
                      :key="`item-${index}`"
                      :item="item"
                      @click="goMenu({code:item.pgmId, menu: item.ename, linkAddr: item.linkAddr})"
                  >
                    <v-icon>mdi-comment-quote-outline</v-icon> {{ item.ename }}
                  </v-card>                
                </v-flex>
              </v-layout>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
        </v-list>

        <template v-slot:append>
          <div class="pa-2">
            <v-btn block @click="logout()">
              Logout
            </v-btn>
          </div>
        </template>
      </v-navigation-drawer>

      <v-snackbar
        v-model="snackbar"
      >
        {{ text }}

        <template v-slot:action="{ attrs }">
          <v-btn
            color="pink"
            text
            v-bind="attrs"
            @click="snackbar = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>

    <!-- mainview -->
    <!-- :style=img_bg_style  -->
    <v-main
      class="fill-height container_bg content--text"
      id="mainContent"
      
    > 
      <router-view @MenuName="getMenuName"/>
      <VueToastify :notifyAction="notifyAction"></VueToastify>
    </v-main>
  </v-app>
</template>

<script>
import { getSystemMenu } from '@/api/system/menuManage'

import ResizeMixin from '@/layout/mixin/ResizeHandler'
import { mapState, Store } from 'vuex'

import { fn_Logout } from '@/framework/login/login'
import DefaultListItem from '@/layout/navbar/ListItem' // single menu
import DefaultListGroup from '@/layout/navbar/ListGroup' // group menu
//import ThemeGenerator from '@/layout/ThemeGenerator.vue' // theme
import TagsView from '@/layout/tagview'
import VueToastify from '@/components/toastify/VueToastify.vue'

import iButton from '@/components/common/iButton'
import localStore from "@/utils/localStore";
import EventBus from '@/components/event-bus';


export default {
    name: 'DefaultLayout',
    components: {
        DefaultListItem,
        DefaultListGroup,
        //ThemeGenerator,
        TagsView,
        VueToastify,
        iButton,
        EventBus 
  },
  mixins: [ResizeMixin],
  data: () => ({
    // i18n
    snackbar: false,
    text: `This Page.vue is not exist`,
    languageMenu: true,
    activeLang: '',
    menuName: "Weather Information System",
    langs: [
      {
        id: 'ko',
        name: '한국어',
        image: require('@/assets/images/flags/ko.png')
      },
      {
        id: 'en',
        name: 'English',
        image: require('@/assets/images/flags/en.png')
      }
    ],
    // main
    group: null,
    drawer: false, //true--(false--> hidden)
    drawerTheme: false,
    toggleBtn: '11',
    menuBtn: '',
    // app-bar
    dialog: false,
    user: {
      initials: '',
      fullName: '',
      email: ''
    },
    userInfo: null,
 
    mailCount: 124,
    image: require(`@/assets/images/bg/bg_login.jpg`),
    systemMenuTreeList:[]
  }),
  watch: {
      group () {
        this.drawer = false
      },
    },
  created() {
    let initial = ''
    const arrName = this.$store.state.user.userNm.split(' ')
    for(let i = 0; i < arrName.length; i++) {
      initial += arrName[i].substr(0, 1)
    }

    this.user = {
      initials: initial,
      fullName: this.$store.state.user.userNm,
      deptNm: this.$store.state.user.deptNm
    }

    this.userInfo = {
      userId: this.$store.state.user.userId,
      sysCd: '20',//this.$store.state.system.sysCd,
      sysId: this.$store.state.system.sysId
    }

    this.setLocale()

    this.$EventBus.$on('App_Bar_MenuClick', e => {
      this.menuClick(e)
    })
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.getSystemMenuList();
    this.sysCd = '20';//this.$store.state.system.sysCd;
    this.addTags();
  },
  computed: {
    ...mapState({
      sidebar: state => state.app.sidebar,
      device: state => state.app.device,
      showSettings: state => state.settings.showSettings,
      needTagsView: state => state.settings.tagsView,
      fixedHeader: state => false, //state.settings.fixedHeader
      isScreenFull: state => state.app.isScreenFull
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    },
    // isMenuName(name) {
    //   return this.$store.getters.getName;
    // },
    key() {
      // console.log("AppMain key : ", this.$route);
      return this.$route.path;
    },
   
    img_bg_style: function(){
        var bgImg= this.image

      return {
                "height": "100",
                "background-image": 'url(' + bgImg + ')', 
                "background-repeat": "no-repeat", 
                "background-size": "cover",
                "background-position": "center",
                "opacity": "1"
      }
    },
  
  },

  watch: {
    $route() {
      this.addTags();
    },
  },

  methods: {
    addTags() {
      const { name } = this.$route;

      if (name) {
        this.$store.dispatch('tagsView/addView', this.$route);
      }

      return false;
    },

    getMenuName(obj) {
      // console.log("#####getMenuName====> : ", obj.code);
      if(obj.code == 'main'||obj.code == null){
        // if(this.userInfo.sysCd!='23'){
        //   this.menuName = "e-Smart " + obj.name;
        // }else{
          this.menuName = obj.name + ' System';
        // }
        
      }else{
        // this.menuName = ''
        this.menuName = obj.name;
      }
      
    },

    isDrawer() {
      this.drawer = !this.drawer
    },
    notifyAction(notifyInfo, action) {
      // console.log('notifyAction',notifyInfo)
      // console.log('notifyAction',action)
      // console.log('notifyAction',this.$route.meta.menu_id)
      this.$EventBus.$emit(`${this.$route.meta.menu_id}_notifyAction`, { notifyInfo: notifyInfo, action: action })
    },
    // Variable to hold the width of the window
    handleResize(e) {
      
      this.windowWidth = window.innerWidth;
      // console.log('handleResize window', window.innerHeight)
      // console.log('handleResize screen', screen.height)
      //Full screen or not
      this.$store.dispatch('app/setIsScreenFull', window.innerHeight == screen.height)
    },
    setLocale() {
        this.activeLang = this.$envs.framework.supportLocales.en
        this.$vuetify.lang.current = 'en'
        this.$i18n.locale = 'en'
      // GetGridMenu     
      this.$store.dispatch('GetGridMenu', this.userInfo)
      this.$EventBus.$emit('lanCode', this.$localStore.get('locale'))      
      
    },
    langClick(lang) {
      this.activeLang = lang
      this.userInfo.lanCode = lang.id 
      // GetGridMenu
      this.$store.dispatch('GetGridMenu', this.userInfo)
      if (lang.id == 'ko') {
        this.$localStore.set('locale', 'ko')
        this.$vuetify.lang.current = 'ko'
        this.$i18n.locale = 'ko'
      } else {
        this.$localStore.set('locale', 'en')
        this.$vuetify.lang.current = 'en'
        this.$i18n.locale = 'en'
      }
      this.$EventBus.$emit('lanCode', lang.id)
    },
    // log out
    logout() {
      fn_Logout()
    },
    changeTheme(theme) {
      if (theme) {
        this.$localStore.set('theme', 'dark')
      } else {
        this.$localStore.set('theme', 'light')
      }
    },
    goMain() { 
    
      this.$router.push('/mainLayout').catch(() => { })      
      
    },
    goHome() { 
    //  console.log('#####goHome====>', '/v'+ this.$store.state.system.sysCd+ 'Menu')
     this.$router.push('/v20Menu').catch(() => { }) 
    },

    /* isVisibleLayout(layout) {
      return this.$store.state.menu.flag[layout] || !this.$store.state.menu.flag.isLayoutHideMode
    }, */

    getSystemMenuList(){
      this.systemMenuTreeList = []
       let param = {
        userId: this.$store.state.user.userId,
        sysCd: '20',//this.$store.state.system.sysCd,
      }
      getSystemMenu(param).then(res => {
        // console.log('########System Menu=====>', res)
        this.systemMenuTreeList = res.list
      })
    },

    goMenu(obj) {
      
      // console.log('#######linkAddr====>', obj.linkAddr)
      // console.log('#######code====>', obj.code)
      this.menuName = obj.menu

      if(obj.code===''||obj.code === null){
        this.snackbar = true        
      }else{
        if (obj.code === 'webpage'){
          window.open(obj.linkAddr)
        }else{
          this.$router.push("/" + obj.code).catch(e => {
          this.vToastify(this.$t('View does not exist.'), 'warn')
          // if (!isNavigationFailure(e, NavigationFailureType.redirected))
          //   Promise.reject(e);
          });
        }
      }
      
    },

    search() {
      // console.log("search: " + this.$route.name);
      const eventName = ["v20a5000", "v20a6000", "v20a7000"].includes(this.$route.name) ? this.$route.name + "m_search" : this.$route.name + "_search";
      EventBus.$emit(eventName);
    },

    // search() {
    //   console.log("search: "+this.$route.name);
    //   if (this.$route.name === "v20a5000"||this.$route.name === "v20a6000") {
    //     EventBus.$emit(this.$route.name + "m_search");
    //   }else{
    //     EventBus.$emit(this.$route.name + "_search");
    //   }
      
    // },
    
  }
}
</script>
<style lang="scss" scoped>

.app_bar_bg {
      border-radius: 0px;
      background: linear-gradient(90deg, #3df383 0%, #039233 100%);
      color: #ffffff !important;
      font-weight: bold;
      font-size: 18px !important;
  }

.theme--light.v-btn-toggle:not(.v-btn-toggle--group) {
  background: #455b59;
  color: rgba(0, 0, 0, 0.87);
}

//side bar group header color change
::v-deep .v-list-group__header {
  background: #f2f6f1 !important;
  padding-left: 10px !important;
}

.main-title{
  width : 100%;
  text-align: center;
  color : white;
  font-weight: bold;
}

</style>